import { Container } from '@mui/material'
import Markdown from 'react-markdown'
import AppBar from '../components/AppBar'
import Wrapper from '../components/Wrapper'
import termsContent from '../docs/terms-of-service.md?raw'

const TermsAndConditions = () => {
  return (
    <>
      <AppBar title='Terms & Conditions' />
      <Wrapper>
        <Container maxWidth='md' sx={{ py: 4 }}>
          <Markdown>{termsContent}</Markdown>
        </Container>
      </Wrapper>
    </>
  )
}

export default TermsAndConditions
